const NodePageConfig = require("@/config/nodeAllPageConfig.js");
import {setPageJsBridgeConfig} from './bridgeConfig.js'
import {setPageWechatConfig} from './wechatConfig.js'



setPageJsBridgeConfig(NodePageConfig);
setPageWechatConfig(NodePageConfig);



export const allPageConfig = NodePageConfig;
export const pageConfig = NodePageConfig[window.PAGE_PATH];

//因为在node环境下需要读取配置去设置每一个页面的标题之类的，所以有了nodePageConfig，但是在前端环境的页面配置也要一份，
//我们也可以在js里面require("@/config/nodePageConfig.js")导入。但是为了统一前端环境导入方式，我们包了一下(只导出当前页面)，统一使用
//import pageConfig from '@/config/clientPageConfig.js'导入
//因为是多页面应用，当前页面由window.PAGE_PATH变量标识，这个是node告诉我们的
